import type React from "react";
import { toast } from "react-hot-toast";
import type { HostAPI } from "../HostAPI";

export class StandaloneHostAPI implements HostAPI {
  private readonly basePath = "/app";

  async getSessionToken(): Promise<string | null> {
    return null;
  }

  toast(message: string): void {
    toast(message);
  }

  openModal(_node: React.ReactNode): void {
    // Integrate with modal library when available
  }

  navigate(path: string): void {
    if (typeof window === "undefined") return;
    const target = path.startsWith("/") ? path : `/${path}`;
    const next = target.startsWith(this.basePath)
      ? target
      : `${this.basePath}${target}`.replace(/\/+/g, "/");
    window.history.pushState({}, "", next);
    window.dispatchEvent(new PopStateEvent("popstate"));
  }

  async fetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    return fetch(input, init);
  }

  async createSubscription(planId?: string): Promise<void> {
    await fetch("/api/billing/stripe/start", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ planId: planId ?? null }),
    });
  }

  async cancelSubscription(): Promise<void> {
    toast("Stripe billing cancellation is not yet available in standalone mode.");
  }
}
